import { render, staticRenderFns } from "./InquiryOpen.vue?vue&type=template&id=34edc6b7&"
import script from "./InquiryOpen.vue?vue&type=script&lang=ts&"
export * from "./InquiryOpen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34edc6b7')) {
      api.createRecord('34edc6b7', component.options)
    } else {
      api.reload('34edc6b7', component.options)
    }
    module.hot.accept("./InquiryOpen.vue?vue&type=template&id=34edc6b7&", function () {
      api.rerender('34edc6b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/assets/Inquiry/InquiryOpen.vue"
export default component.exports